// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"363b4cee9cc08e368075","303":"aad4152c33a9d981925d","495":"f698d01cd05eb849e5ae"}[chunkId] + ".js";
};